export type DealLabel = 'EXCELLENT' | 'GOOD' | 'FAIR' | 'EXPENSIVE'

export function classifyDeal(price: number, avgPrice: number): DealLabel {
    if (!Number.isFinite(price) || !Number.isFinite(avgPrice) || avgPrice <= 0) return 'FAIR'
    const ratio = price / avgPrice
    if (ratio <= 0.8) return 'EXCELLENT'
    if (ratio <= 0.95) return 'GOOD'
    if (ratio <= 1.15) return 'FAIR'
    return 'EXPENSIVE'
}

